import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import StageNotify from './app/components/StageNotify/StageNotify';
import Login from './app/views/Login/Login';

import { getCustomState } from './util/LocalStorage';
import { SESSION_STATE, USER_DATA } from './util/constants/AppConstants';
import Preload from './util/Preload';
import AppRoutes from './util/Routes';

const App = () => {
  const session = useSelector((state) => state.session.session);
  const config = useSelector((state) => state.config.config);

  const [sessionState, setSessionState] = useState(true);
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const storedSession = getCustomState(SESSION_STATE);
    const isLoggedIn = !!session || !!storedSession;
    const storedUserData = getCustomState(USER_DATA, true);

    setSessionState(isLoggedIn);
    setUserInfo(storedUserData);
    document.body.classList.toggle('login', !isLoggedIn);
  }, [session]);

  return (
    <div className="App">
      <Preload />
      {config && config.env === 'staging' && <StageNotify />}
      {!sessionState && <Login />}
      <AppRoutes sessionState={sessionState} userInfo={userInfo} />
    </div>
  );
};

export default App;
